import React from 'react'

const Fotter = () => {
  return (
    <section id='Footer' className='mt-[50px]'>
<div className='max-w-container mx-auto w-full h-[200px] lg:flex flex-wrap'>
    
<div className=' lg:w-1/3 h-full  pt-[40px] w-full'>

<div className='w-[357px] h-[135px] bg-[#FDEDE8] mx-auto border-[1px] border-[#FAD0BC] border-solid rounded-[15px]'>

    <div className='flex'>
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="35" viewBox="0 0 29 35" fill="none" className='mt-[49px] ml-[24.5px]'>
  <g clip-path="url(#clip0_18_24)">
    <path d="M21.223 24.876L22.8204 23.9258C23.436 25.4912 24.2625 26.8789 25.2664 28.0889C27.1522 25.1836 28.2892 21.5059 28.2892 17.5C28.2892 13.501 27.1577 9.83008 25.283 6.93164C24.2957 8.11426 23.4749 9.46777 22.8648 10.999L21.2729 10.0352C21.9829 8.25781 22.9369 6.68555 24.0905 5.31836C21.6168 2.37207 18.2557 0.546875 14.5396 0.546875C10.829 0.546875 7.46787 2.36523 4.99417 5.31152C6.14228 6.67188 7.09626 8.24414 7.80621 10.0146L6.21438 10.9785C5.60427 9.4541 4.78895 8.10059 3.80168 6.91797C1.9159 9.82324 0.784424 13.4941 0.784424 17.5C0.784424 21.5059 1.9159 25.1768 3.80168 28.0752C4.81113 26.8652 5.6431 25.4775 6.25875 23.9053L7.85612 24.8555C7.14063 26.6807 6.17556 28.2939 4.99971 29.6885C7.46787 32.6348 10.829 34.4531 14.5396 34.4531C18.2446 34.4531 21.6002 32.6416 24.0739 29.7021C22.9036 28.3076 21.9385 26.7012 21.223 24.876ZM8.56052 22.6885L6.86886 22.0186C7.69528 18.8467 7.57326 15.6064 6.83558 12.8584L8.5217 12.1748C9.35366 15.292 9.52005 19.0039 8.56052 22.6885ZM20.5575 12.2021L22.2436 12.8857C21.5114 15.627 21.3839 18.8672 22.2103 22.0459L20.5186 22.7158C19.5591 19.0244 19.7255 15.3125 20.5575 12.2021Z" fill="black"/>
  </g>
  <defs>
    <clipPath id="clip0_18_24">
      <rect width="28.3977" height="35" fill="white" transform="translate(0.34082)"/>
    </clipPath>
  </defs>
</svg>
<span className='w-[1px] h-[82px] bg-[#FAD0BC] ml-[21px] mt-[26px] mr-[26px]'></span>
<div className='pt-[30px]'>
    <h2 className=' font-robot font-medium text-[20px] text-[black]'>Immediate Deployment</h2>
    <p className='font-robot font-medium text-[16px] text-[#71717A] pt-[7px]'>Et vero eos et accusamus et <br />
iusto odio dignissimos</p>
</div>
    </div>

</div>
</div>








<div className='lg:w-1/3 h-full pt-[40px] w-full'>
<div className='w-[357px] h-[135px] bg-[#FDEDE8] text-center items-center mx-auto border-[1px] border-[#FAD0BC] border-solid rounded-[15px]'>


<div className='flex'>
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="35" viewBox="0 0 29 35" fill="none" className='mt-[49px] ml-[24.5px]'>
  <g clip-path="url(#clip0_18_24)">
    <path d="M21.223 24.876L22.8204 23.9258C23.436 25.4912 24.2625 26.8789 25.2664 28.0889C27.1522 25.1836 28.2892 21.5059 28.2892 17.5C28.2892 13.501 27.1577 9.83008 25.283 6.93164C24.2957 8.11426 23.4749 9.46777 22.8648 10.999L21.2729 10.0352C21.9829 8.25781 22.9369 6.68555 24.0905 5.31836C21.6168 2.37207 18.2557 0.546875 14.5396 0.546875C10.829 0.546875 7.46787 2.36523 4.99417 5.31152C6.14228 6.67188 7.09626 8.24414 7.80621 10.0146L6.21438 10.9785C5.60427 9.4541 4.78895 8.10059 3.80168 6.91797C1.9159 9.82324 0.784424 13.4941 0.784424 17.5C0.784424 21.5059 1.9159 25.1768 3.80168 28.0752C4.81113 26.8652 5.6431 25.4775 6.25875 23.9053L7.85612 24.8555C7.14063 26.6807 6.17556 28.2939 4.99971 29.6885C7.46787 32.6348 10.829 34.4531 14.5396 34.4531C18.2446 34.4531 21.6002 32.6416 24.0739 29.7021C22.9036 28.3076 21.9385 26.7012 21.223 24.876ZM8.56052 22.6885L6.86886 22.0186C7.69528 18.8467 7.57326 15.6064 6.83558 12.8584L8.5217 12.1748C9.35366 15.292 9.52005 19.0039 8.56052 22.6885ZM20.5575 12.2021L22.2436 12.8857C21.5114 15.627 21.3839 18.8672 22.2103 22.0459L20.5186 22.7158C19.5591 19.0244 19.7255 15.3125 20.5575 12.2021Z" fill="black"/>
  </g>
  <defs>
    <clipPath id="clip0_18_24">
      <rect width="28.3977" height="35" fill="white" transform="translate(0.34082)"/>
    </clipPath>
  </defs>
</svg>
<span className='w-[1px] h-[82px] bg-[#FAD0BC] ml-[21px] mt-[26px] mr-[26px]'></span>
<div className='pt-[30px]'>
    <h2 className=' font-robot font-medium text-[20px] text-[black]'>Immediate Deployment</h2>
    <p className='font-robot font-medium text-[16px] text-[#71717A] pt-[7px]'>Et vero eos et accusamus et <br />
iusto odio dignissimos</p>
</div>
    </div>
</div>
</div>



<div className='lg:w-1/3 h-full pt-[40px] w-full'>
<div className='w-[357px] h-[135px] bg-[#FDEDE8] text-center items-center mx-auto border-[1px] border-[#FAD0BC] border-solid rounded-[15px]'>

<div className='flex'>
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="35" viewBox="0 0 29 35" fill="none" className='mt-[49px] ml-[24.5px]'>
  <g clip-path="url(#clip0_18_24)">
    <path d="M21.223 24.876L22.8204 23.9258C23.436 25.4912 24.2625 26.8789 25.2664 28.0889C27.1522 25.1836 28.2892 21.5059 28.2892 17.5C28.2892 13.501 27.1577 9.83008 25.283 6.93164C24.2957 8.11426 23.4749 9.46777 22.8648 10.999L21.2729 10.0352C21.9829 8.25781 22.9369 6.68555 24.0905 5.31836C21.6168 2.37207 18.2557 0.546875 14.5396 0.546875C10.829 0.546875 7.46787 2.36523 4.99417 5.31152C6.14228 6.67188 7.09626 8.24414 7.80621 10.0146L6.21438 10.9785C5.60427 9.4541 4.78895 8.10059 3.80168 6.91797C1.9159 9.82324 0.784424 13.4941 0.784424 17.5C0.784424 21.5059 1.9159 25.1768 3.80168 28.0752C4.81113 26.8652 5.6431 25.4775 6.25875 23.9053L7.85612 24.8555C7.14063 26.6807 6.17556 28.2939 4.99971 29.6885C7.46787 32.6348 10.829 34.4531 14.5396 34.4531C18.2446 34.4531 21.6002 32.6416 24.0739 29.7021C22.9036 28.3076 21.9385 26.7012 21.223 24.876ZM8.56052 22.6885L6.86886 22.0186C7.69528 18.8467 7.57326 15.6064 6.83558 12.8584L8.5217 12.1748C9.35366 15.292 9.52005 19.0039 8.56052 22.6885ZM20.5575 12.2021L22.2436 12.8857C21.5114 15.627 21.3839 18.8672 22.2103 22.0459L20.5186 22.7158C19.5591 19.0244 19.7255 15.3125 20.5575 12.2021Z" fill="black"/>
  </g>
  <defs>
    <clipPath id="clip0_18_24">
      <rect width="28.3977" height="35" fill="white" transform="translate(0.34082)"/>
    </clipPath>
  </defs>
</svg>
<span className='w-[1px] h-[82px] bg-[#FAD0BC] ml-[21px] mt-[26px] mr-[26px]'></span>
<div className='pt-[30px]'>
    <h2 className=' font-robot font-medium text-[20px] text-[black]'>Immediate Deployment</h2>
    <p className='font-robot font-medium text-[16px] text-[#71717A] pt-[7px]'>Et vero eos et accusamus et <br />
iusto odio dignissimos</p>
</div>
    </div>
</div>
</div>
















</div>
    </section>
  )
}

export default Fotter